import { Box, BoxProps } from 'theme-ui'

export function CalendarIcon({
  size = 20,
  color = '#ffc436',
}: {
  size?: number | string
  color?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M7 9H5V11H7V9ZM11 9H9V11H11V9ZM15 9H13V11H15V9ZM17 2H16V0H14V2H6V0H4V2H3C1.89 2 1.01 2.9 1.01 4L1 18C1 19.1 1.89 20 3 20H17C18.1 20 19 19.1 19 18V4C19 2.9 18.1 2 17 2ZM17 18H3V7H17V18Z"
        fill={color}
      />
    </svg>
  )
}

export function CalendarNavChevron() {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none">
      <path stroke="#fff" d="M10.818 8.818L14 12l-1.591 1.591-1.591 1.591" />
    </svg>
  )
}

export function NewWindowIcon() {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={8}
      height={8}
      fill="none">
      <path
        fill="#26344A"
        d="M1.262 0l2.529 2.524L0 6.314 1.685 8l3.79-3.79L8 6.732V0H1.263z"
        opacity="0.6"
      />
    </svg>
  )
}

export function InfoIcon() {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.555 1.348a8 8 0 118.89 13.304 8 8 0 01-8.89-13.304zm.692 12.269A6.756 6.756 0 008 14.756 6.764 6.764 0 0014.756 8a6.755 6.755 0 10-10.51 5.617zM8 4.377a.698.698 0 100-1.396.698.698 0 000 1.396zm1.854 6.744a4.964 4.964 0 00-.55.271c-.384.21-.606.332-.606-.113V5.913c0-.723-.735-.921-1.396-.502-.47.298-.752.647-1.019.98-.111.138-.22.273-.34.4a.186.186 0 00.202.302c.208-.083.393-.184.55-.27.384-.21.607-.333.607.113V12.3c0 .723.734.922 1.396.503.47-.298.752-.648 1.019-.98.111-.138.22-.273.34-.4a.186.186 0 00-.203-.303z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export function CloseIcon({ size = 10, color = '#26344A' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 16 16`}
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2L14.0063 14L2 2Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0063 2L2 14L14.0063 2Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MoreOptionsIcon() {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={23}
      height={5}
      fill="none">
      <path
        fill="#FFC436"
        d="M13.5 2.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM4.5 2.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM22.5 2.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
      />
    </svg>
  )
}

export function ChevronDownIcon() {
  return (
    <svg
      role="img"
      width={10}
      height={6}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M.41.352L5 4.942l2.295-2.295L9.589.352" stroke="#26344A" />
    </svg>
  )
}

export function EmptyListIcon() {
  return (
    <svg
      role="img"
      width="108"
      height="83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.812 79.633h23.266c.633 0 1.188.736 1.188 1.576 0 .84-.554 1.576-1.188 1.576H32.812c-.633 0-1.187-.735-1.187-1.576 0-.84.554-1.576 1.187-1.576zM69.187 44h23.266c.633 0 1.188.736 1.188 1.577 0 .84-.555 1.575-1.188 1.575H69.187c-.633 0-1.187-.735-1.187-1.575 0-.841.554-1.576 1.187-1.576zM64.187 51H106.5c.633 0 1.187.736 1.187 1.577 0 .84-.554 1.575-1.187 1.575H64.187c-.633 0-1.187-.735-1.187-1.575 0-.841.554-1.576 1.187-1.576zM60.188 58h23.266c.634 0 1.188.736 1.188 1.577 0 .84-.554 1.575-1.188 1.575H60.188c-.633 0-1.187-.735-1.187-1.575 0-.841.554-1.576 1.187-1.576z"
        fill="#FFC436"
      />
      <circle
        cx="6.838"
        cy="6.838"
        r="5.038"
        stroke="#FFC436"
        strokeWidth="3.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.163 7.434L68.59 21.787c.972 1.047 1.495 2.317 1.495 3.738v14.473h-2.617V26.272H54.238a3.51 3.51 0 01-3.514-3.513V9.452H22.766a1.34 1.34 0 00-1.346 1.346v59.356a1.34 1.34 0 001.346 1.345h43.358c.747 0 1.345-.598 1.345-1.27v-3.231h2.617v3.23c0 2.168-1.794 3.962-3.962 3.962H22.766c-2.168 0-3.962-1.794-3.962-3.962v-59.43c0-2.168 1.794-3.962 3.962-3.962h29.902c.523 0 1.046.224 1.495.598zm.075 16.222h11.96L53.266 10.723v11.961a.99.99 0 00.972.972z"
        fill="#FFC436"
      />
      <path
        d="M68.59 21.787l.367-.34-.007-.008-.007-.006-.352.354zM54.164 7.434l.353-.354-.016-.016-.017-.014-.32.384zm15.923 32.564v.5h.5v-.5h-.5zm-2.617 0h-.5v.5h.5v-.5zm0-13.726h.5v-.5h-.5v.5zM50.724 9.452h.5v-.5h-.5v.5zM67.47 66.998v-.5h-.5v.5h.5zm2.617 0h.5v-.5h-.5v.5zm-3.888-43.342v.5h1.208l-.854-.854-.354.354zM53.266 10.723l.353-.353-.853-.854v1.207h.5zm15.677 10.71L54.516 7.08l-.706.708 14.428 14.353.705-.708zm1.643 4.092c0-1.553-.576-2.944-1.629-4.078l-.733.68c.89.959 1.362 2.11 1.362 3.398h1zm0 14.473V25.525h-1v14.473h1zm-3.117.5h2.617v-1h-2.617v1zm-.5-14.226v13.726h1V26.272h-1zm-12.731.5h13.231v-1H54.238v1zm-4.014-4.013a4.01 4.01 0 004.014 4.013v-1a3.01 3.01 0 01-3.014-3.013h-1zm0-13.307V22.76h1V9.452h-1zm-27.458.5h27.958v-1H22.766v1zm-.846.846a.84.84 0 01.846-.846v-1a1.84 1.84 0 00-1.846 1.846h1zm0 59.356V10.798h-1v59.356h1zm.846.845a.84.84 0 01-.846-.845h-1a1.84 1.84 0 001.846 1.845v-1zm43.358 0H22.766v1h43.358v-1zm.845-.77c0 .378-.355.77-.845.77v1c1.005 0 1.845-.803 1.845-1.77h-1zm0-3.231v3.23h1v-3.23h-1zm3.117-.5h-2.617v1h2.617v-1zm.5 3.73v-3.23h-1v3.23h1zm-4.462 4.462c2.444 0 4.462-2.018 4.462-4.462h-1c0 1.892-1.57 3.462-3.462 3.462v1zm-43.358 0h43.358v-1H22.766v1zm-4.462-4.462c0 2.444 2.018 4.462 4.462 4.462v-1c-1.892 0-3.462-1.57-3.462-3.462h-1zm0-59.43v59.43h1v-59.43h-1zm4.462-4.462c-2.444 0-4.462 2.018-4.462 4.462h1c0-1.892 1.57-3.462 3.462-3.462v-1zm29.902 0H22.766v1h29.902v-1zm1.815.714c-.516-.43-1.148-.714-1.815-.714v1c.38 0 .794.164 1.175.482l.64-.768zm11.715 16.106h-11.96v1h11.96v-1zm-13.286-12.08L65.845 24.01l.707-.707L53.619 10.37l-.707.707zm.854 11.608v-11.96h-1v11.96h1zm.472.472a.49.49 0 01-.472-.472h-1c0 .8.672 1.472 1.472 1.472v-1z"
        fill="#FFC436"
      />
    </svg>
  )
}

export function SearchIcon({ size = 26 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      viewBox="0 -2 19 21"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4329 13.0395L16.6852 16.3468C17.108 16.7759 17.108 17.4677 16.6665 17.8968C16.4641 18.1019 16.1885 18.2143 15.9128 18.2143C15.6372 18.2143 15.3616 18.1026 15.1591 17.8968L11.7784 14.4597C10.6027 15.207 9.20578 15.655 7.69911 15.655C3.45484 15.655 0 12.1433 0 7.82752C0 3.51171 3.45466 0 7.69984 0C11.9441 0 15.3989 3.51153 15.3989 7.82752C15.3989 9.82634 14.646 11.6573 13.4329 13.0395ZM7.69902 2.18545C4.63044 2.18545 2.1497 4.72568 2.1497 7.82732C2.1497 10.9471 4.649 13.4692 7.69976 13.4692C10.7498 13.4692 13.2305 10.9288 13.2305 7.82732C13.2305 4.72587 10.7683 2.18545 7.69902 2.18545Z"
        fill="#26344A"
      />
    </svg>
  )
}

export function FilterIcon() {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 12a1 1 0 110 2H7a1 1 0 110-2h2zm3-5a1 1 0 110 2H4a1 1 0 110-2h8zm3-5a1 1 0 110 2H1a1 1 0 110-2h14z"
        fill="currentColor"
      />
    </svg>
  )
}

export function NextPageArrow() {
  return (
    <svg width={11} height={10} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5.41L10.09 5 7.794 7.295 5.5 9.589" stroke="#26344A" />
    </svg>
  )
}

export function PreviousPageArrow() {
  return (
    <svg width={11} height={10} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 9.59L.911 5l2.295-2.295L5.5.411" stroke="#26344A" />
    </svg>
  )
}

export function SortingIcon({ ...rest }: BoxProps) {
  return (
    <Box {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" fill="none">
        <path fill="#171515" d="M5.5 0l4.763 7.5H.737L5.5 0z" />
      </svg>
    </Box>
  )
}

export function MenuIcon({
  width = 27,
  height = 18,
  ...rest
}: { width?: number; height?: number } & BoxProps) {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 27 19"
        fill="none">
        <path
          d="M1 8.49978C0.447715 8.49978 0 8.94749 0 9.49978C0 10.0521 0.447715 10.4998 1 10.4998V8.49978ZM25.7273 10.4998C26.2796 10.4998 26.7273 10.0521 26.7273 9.49978C26.7273 8.94749 26.2796 8.49978 25.7273 8.49978V10.4998ZM1 10.4998H25.7273V8.49978H1V10.4998Z"
          fill="#26344A"
        />

        <path
          d="M1 0.772727C0.447715 0.772727 0 1.22044 0 1.77273C0 2.32501 0.447715 2.77273 1 2.77273V0.772727ZM25.7273 2.77273C26.2796 2.77273 26.7273 2.32501 26.7273 1.77273C26.7273 1.22044 26.2796 0.772727 25.7273 0.772727V2.77273ZM1 2.77273H25.7273V0.772727H1V2.77273Z"
          fill="#26344A"
        />
        <path
          d="M1 16.2273C0.447715 16.2273 0 16.675 0 17.2273C0 17.7796 0.447715 18.2273 1 18.2273V16.2273ZM25.7273 18.2273C26.2796 18.2273 26.7273 17.7796 26.7273 17.2273C26.7273 16.675 26.2796 16.2273 25.7273 16.2273V18.2273ZM1 18.2273H25.7273V16.2273H1V18.2273Z"
          fill="#26344A"
        />
      </svg>
    </Box>
  )
}
export function CreateUserIcon({
  size = 20,
  ...rest
}: { size?: number } & BoxProps) {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <ellipse
          cx="7.50008"
          cy="5.83333"
          rx="3.33333"
          ry="3.33333"
          stroke="#26344A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 17.5V15.8333C2.5 13.9924 3.99238 12.5 5.83333 12.5H9.16667C11.0076 12.5 12.5 13.9924 12.5 15.8333V17.5"
          stroke="#26344A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 8.1665C12.781 8.1665 12.3333 8.61422 12.3333 9.1665C12.3333 9.71879 12.781 10.1665 13.3333 10.1665V8.1665ZM18.3333 10.1665C18.8855 10.1665 19.3333 9.71879 19.3333 9.1665C19.3333 8.61422 18.8855 8.1665 18.3333 8.1665V10.1665ZM16.8333 6.6665C16.8333 6.11422 16.3855 5.6665 15.8333 5.6665C15.281 5.6665 14.8333 6.11422 14.8333 6.6665H16.8333ZM14.8333 11.6665C14.8333 12.2188 15.281 12.6665 15.8333 12.6665C16.3855 12.6665 16.8333 12.2188 16.8333 11.6665H14.8333ZM13.3333 10.1665H18.3333V8.1665H13.3333V10.1665ZM14.8333 6.6665V11.6665H16.8333V6.6665H14.8333Z"
          fill="#26344A"
        />
      </svg>
    </Box>
  )
}
export function TrashIcon({
  stroke = '#F3AD03',
  ...rest
}: BoxProps & { stroke?: string }) {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M4 7H20"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11V17"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11V17"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 7L6 19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19L19 7"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 7V4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V7"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  )
}

export function EditIcon({
  stroke = '#F3AD03',
  ...rest
}: BoxProps & { stroke?: string }) {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M9 7H6C4.89543 7 4 7.89543 4 9V18C4 19.1046 4.89543 20 6 20H15C16.1046 20 17 19.1046 17 18V15"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 15H12L20.5 6.49998C21.3284 5.67156 21.3284 4.32841 20.5 3.49998C19.6716 2.67156 18.3284 2.67156 17.5 3.49998L9 12V15"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 5L19 8"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  )
}

export function AddIcon({
  stroke = '#F3AD03',
  ...rest
}: BoxProps & { stroke?: string }) {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
          fill="white"
          stroke={stroke}
          strokeWidth="2"
        />
        <rect x="9" y="5" width="2" height="10" rx="1" fill={stroke} />
        <rect
          x="15"
          y="9"
          width="2"
          height="10"
          rx="1"
          transform="rotate(90 15 9)"
          fill={stroke}
        />
      </svg>
    </Box>
  )
}

export const LocationIcon = ({
  stroke = '#F3AD03',
  ...rest
}: BoxProps & { stroke?: string }) => {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="21"
        viewBox="0 0 17 21"
        fill="none">
        <path
          d="M7.35991 1.00188C3.75892 1.53016 1.00012 4.52169 1.00012 8.13313C1.00012 8.13313 0.998572 8.22021 1.00671 8.38137C1.02133 8.79633 1.07056 9.20286 1.155 9.59721C1.53429 11.6906 2.84 15.7034 7.32912 19.4666C8.00077 20.0297 8.99929 20.0297 9.67094 19.4666C14.16 15.7034 15.4659 11.6906 15.8452 9.59721C15.9296 9.20286 15.9787 8.79633 15.9934 8.38137C16.0016 8.22021 15.9998 8.13313 15.9998 8.13313C15.9998 4.43571 13.3661 1.52342 9.62512 1"
          stroke="#FFC436"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.88888 8.00553C9.88888 8.90349 9.14273 9.63155 8.22232 9.63155C7.3018 9.63155 6.55554 8.90349 6.55554 8.00553C6.55554 7.10758 7.3018 6.37952 8.22232 6.37952C9.14273 6.37952 9.88888 7.10758 9.88888 8.00553Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  )
}

export const TimeInputIcon = ({
  stroke = '#F3AD03',
  width = 20,
  height = 20,
  ...rest
}: BoxProps & { stroke?: string; width?: number; height?: number }) => {
  return (
    <Box {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none">
        <g clipPath="url(#clip0_1596_23766)">
          <path
            d="M11.99 3C6.47 3 2 7.48 2 13C2 18.52 6.47 23 11.99 23C17.52 23 22 18.52 22 13C22 7.48 17.52 3 11.99 3ZM12 21C7.58 21 4 17.42 4 13C4 8.58 7.58 5 12 5C16.42 5 20 8.58 20 13C20 17.42 16.42 21 12 21Z"
            fill={stroke}
          />
          <path
            d="M12.5 8H11V14L16.25 17.15L17 15.92L12.5 13.25V8Z"
            fill={stroke}
          />
        </g>
        <defs>
          <clipPath id="clip0_1596_23766">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  )
}

export const BackBtn = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M20 10C20 9.30964 19.4404 8.75 18.75 8.75H4.7875L10.8875 2.65001C11.3771 2.16036 11.3757 1.36605 10.8844 0.878136C10.3954 0.392654 9.60595 0.394049 9.11874 0.881256L0.707106 9.29289C0.316582 9.68342 0.316583 10.3166 0.707107 10.7071L9.11836 19.1184C9.60528 19.6053 10.3947 19.6053 10.8816 19.1184C11.3683 18.6317 11.3686 17.8429 10.8824 17.3559L4.7875 11.25H18.75C19.4404 11.25 20 10.6904 20 10Z"
        fill="#FFC436"
      />
    </svg>
  )
}

export const PhoneCall = ({ size = 24 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 20.1046 19.1046 21 18 21C9.92765 20.5094 3.49056 14.0724 3 6C3 4.89543 3.89543 4 5 4"
        stroke="#FFC436"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7C16.1046 7 17 7.89543 17 9"
        stroke="#FFC436"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3C18.3137 3 21 5.68629 21 9"
        stroke="#FFC436"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Copy = ({
  size = 24,
  color = '#FFB619',
}: {
  size?: number
  color?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none">
      <rect
        x="8"
        y="8"
        width="12"
        height="12"
        rx="2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 8V6C16 4.89543 15.1046 4 14 4H6C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
